export default __webpack_public_path__ + "static/image-9090-13cc3f431fdba4259b1fb67b99c2e1e6.png";